/* eslint-disable react-refresh/only-export-components */
import React, { CSSProperties, PropsWithChildren, useImperativeHandle, useRef, useState } from 'react';
import type { DialogProps } from 'tdesign-react';
import { Button, FormProps } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { wrapAsyncFunction } from '@/utils';

import { FormComponent } from '../../index';
import type { ICustomConfig, IFormItemProps, IFormValue, IRenderType } from '../../interface';
import styles from './index.module.less';

export interface IBaseFormHandle {
  formRef: any;
}

type BaseFormProps = {
  cRef?: any;
  isVisible?: boolean;
  fieldsConfig: IFormItemProps[];
  formData?: IFormValue;
  onSubmit: (params: any) => Promise<any>;
  onClose: () => void;
  dialogConfig: DialogProps;
  formConfig?: FormProps;
  customRender?: { [key: string]: IRenderType };
  customConfig?: ICustomConfig;
  layOutConfig?: CSSProperties;
  topRender?: React.ReactNode;
  refactorFieldsConfig?: (configs: IFormItemProps[]) => IFormItemProps[];
};

const DialogForm: React.ForwardRefRenderFunction<IBaseFormHandle, PropsWithChildren<BaseFormProps>> = (
  props,
  _refs,
) => {
  useImperativeHandle(props.cRef, () => ({
    formRef: formRef.current,
  }));

  const { dialogConfig,
    fieldsConfig,
    formData,
    formConfig = {},
    customRender = {},
    customConfig = {},
    refactorFieldsConfig,
  } = props;
  const formRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const onSubmit = async (values: any) => {
    const ret = await props.onSubmit(values);
    setLoading(false);
    if (ret !== false) {
      handleClose();
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    formRef.current.handleSubmit();
  };

  const handleClose = () => {
    setLoading(false);
    props.onClose();
  };

  return (
    <NovaDialog
      dialogConfig={{
        visible: props.isVisible,
        confirmBtn: <Button loading={loading} onClick={handleSubmit}> 确定
        </Button>,
        cancelBtn: <Button theme="default" variant="outline" onClick={handleClose}> 取消
        </Button>,
        onClose: handleClose,
        style: { padding: 20 },
        ...dialogConfig,
      }}
      {...dialogConfig}
    >
      <div style={props.layOutConfig} className={styles.layout}>
        {props?.topRender}
        <FormComponent
          cRef={formRef}
          fieldsConfig={fieldsConfig}
          formData={formData}
          formConfig={formConfig}
          onSubmit={wrapAsyncFunction(onSubmit)}
          onSubmitFail={() => setLoading(false)}
          customRender={customRender}
          customConfig={customConfig}
          refactorFieldsConfig={refactorFieldsConfig}
        ></FormComponent>
        {props.children}
      </div>
    </NovaDialog>
  );
};

export default React.forwardRef(DialogForm);
